import { Article } from '../../molecules/article/article';
import { Container } from '../../molecules/container/Container';
import { Main } from '../../molecules/main/Main';
import { PageSection } from '../../molecules/pageSection/PageSection';
import { Footer } from '../footer/Footer';
import { Header } from '../header/Header';
import { PageWrapper } from './PageWrapper';

export function PageWrapperWithHeader({ children }: { children: React.ReactNode }) {
    return (
        <PageWrapper>
            <Header
                backButtonText="Terug"
                hasBackbutton
                hasLogoutButton
            />
            <Main>
                <Container isFluidOnMobile>
                    <PageSection>
                        <Article>{children}</Article>
                    </PageSection>
                </Container>
            </Main>
            <Footer />
        </PageWrapper>
    );
}
